import lboIcon from 'assets/images/lbo-white.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { close as closeModal } from '../../../modules/modal/actions';

export const ShopIdNotFound = ({ close }) => (
  <div className="modal shop-id-not-found">
    <img src={lboIcon} className="enter-shop-id__icon" />
    <h2 className="shop-id-not-found__header">Licensed Betting Office Not Found</h2>
    <p className="shop-id-not-found__paragraph">
      Please enter a valid Licensed Betting Office number
      to ensure PLUS sign-ups are tracked correctly.
    </p>
    <Button
      className="modal__button"
      onClick={close}
    >
      Back
    </Button>
  </div>
);

ShopIdNotFound.propTypes = {
  close: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  close: closeModal
};

export default connect(null, mapDispatchToProps)(ShopIdNotFound);
